import type { ReactElement } from 'react';

import type { ToolbarButton } from './ToolbarButton';

export class ToolbarButtons {
  private readonly _toolbarButtons: ToolbarButton[];

  constructor(toolbarButtons: ToolbarButton[]) {
    this._toolbarButtons = toolbarButtons;
  }

  public get toolbarButtons() {
    return this._toolbarButtons;
  }

  getButtonByIndex(index: number): ToolbarButton {
    return this._toolbarButtons[index];
  }

  isEmpty() {
    return this._toolbarButtons.length === 0;
  }

  addButton(toolbarButton: ToolbarButton) {
    this._toolbarButtons.push(toolbarButton);
  }

  getButtonsElements(): ReactElement[] {
    return this._toolbarButtons.map(toolbarButton => toolbarButton.getButtonElement());
  }

  getButtonsElementsWithDataHook(): ReactElement[] {
    return this._toolbarButtons.map(toolbarButton => toolbarButton.getButtonElementWithDataHook());
  }

  getFirstButtonDataHook(): string | null {
    if (this.isEmpty()) return null;
    const firstButton = this._toolbarButtons[0];
    return firstButton.getButtonDataHook();
  }

  getLastButtonDataHook(): string | null {
    if (this.isEmpty()) return null;
    const lastButton = this._toolbarButtons[this._toolbarButtons.length - 1];
    return lastButton.getButtonDataHook();
  }
}
